import { GET } from "../../API/get"

export const fetchStages = async () => {
    const response = await GET('ftm/stages');
    return response.status === "Success" ? response : null;
}